import { useMemo, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "./Login.css";

import vdo from "../../assets/video.mp4";
import { servicePostLoginAdmin } from "../../api/serviceFleetMaster";

const Login = () => {
  const navigate = useNavigate();

  const [input, setInput] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const canSubmit = useMemo(() => {
    if (loading) return false;
    if (!input.trim()) return false;
    if (!password) return false;
    return true;
  }, [input, password, loading]);

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit) return;

    if (!input || !password) {
      toast.error("Missing credentials");
    }

    setLoading(true);

    try {
      const payload = {
        input: input.trim(),
        password: password,
      };

      const userData = await servicePostLoginAdmin(payload);

      if (!userData?.id || !userData?.token) {
        throw new Error("Invalid login response");
      }

      sessionStorage.setItem("identifier", input.trim());

      sessionStorage.setItem("token", userData.token);
      sessionStorage.setItem("id", userData.id);
      sessionStorage.setItem("org_code", userData.code);
      sessionStorage.setItem("user_role", userData.role);

      navigate("/", { replace: true });
    } catch (error) {
      if (error.status === 401 || error.status === 404) {
        toast.warn("User not found.", error.status);
      } else {
        console.log(
          `Authentication failed${error.message ? `: ${error.message}` : ""}`,
        );
        toast.error(
          `Authentication failed${error.message ? `: ${error.message}` : ""}`,
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      {/* Video background */}
      <div className="login-video">
        <video autoPlay muted loop playsInline className="login-video-el">
          <source src={vdo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="login-video-overlay" />
      </div>

      {/* Header bar (theme-aligned) */}
      {/* <img src={logoFM} alt="Fleet Master" className="login-logo" /> */}

      {/* Center card */}
      <main className="login-main">
        <div className="login-card" aria-busy={loading ? "true" : "false"}>
          {loading ? (
            <div className="login-status">
              <span className="login-spinner" aria-hidden="true" />
              Authenticating…
            </div>
          ) : (
            <div className="login-status is-idle">
              <i className="bi bi-check2" aria-hidden="true" />
              Ready
            </div>
          )}

          <form className="login-form" onSubmit={handleLoginSubmit}>
            <div className="login-form-head">
              <div className="login-form-title">Sign in</div>
              <div className="login-form-sub">
                Enter sign in credentails provided to your organization.
              </div>
            </div>

            <div className="login-grid">
              <div className="login-field login-field-wide">
                <div className="login-label">Credential</div>
                <input
                  type="text"
                  className="login-input"
                  placeholder="Enter email or username..."
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  disabled={loading}
                  autoComplete="text"
                  required
                />
              </div>

              <div className="login-field login-field-wide">
                <div className="login-label">Password</div>
                <input
                  type="password"
                  className="login-input"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={loading}
                  autoComplete="current-password"
                  required
                />
              </div>
            </div>

            <div className="login-actions">
              <button
                type="submit"
                className="login-btn login-btn-primary"
                disabled={!canSubmit}
                title={!canSubmit ? "Fill all fields to continue" : undefined}
              >
                <i className="bi bi-box-arrow-in-right" aria-hidden="true" />
                <span>{loading ? "Loading…" : "Login"}</span>
              </button>

              <a className="login-link" href="/reset">
                Forgot your password?
              </a>
            </div>

            <div className="login-footnote">
              By continuing you agree to the organization access policies.
            </div>
          </form>
        </div>
      </main>
    </div>
  );
};

export default Login;
